import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Rectangle from "../../static/img/Rectangle124.png"
import Rectangle2 from "../../static/img/Rectangle123.png"


const PersonalInformation: React.FC = () => {
    const { t } = useTranslation()


    const goBackPage = () => {
        window.history.back()
    }

    useEffect(() => {

        window.scrollTo(0, 0);
    
    }, []);

    return <div style={{ backgroundColor: '#37383D'}}>
        <div style={{ height: '64px',display:'flex',flexDirection:'row',alignItems:'center',paddingRight:'44px'}}>
            <img src={require("../../static/img/xljt.png")} style={{ width: '24px', height: '24px', marginRight: '10px',marginLeft:'20px',cursor: 'pointer'}} onClick={() => goBackPage()}></img>
            <div style={{ color: '#BABBBE', lineHeight: '64px', textAlign: 'center', fontSize: '15px',flex:1 }}>Marianna{t('CardLinker')}</div>
        </div>
        <div style={{ margin: '20px', zIndex: 999,  marginTop: '10px' }}>
            <div style={{ backgroundImage: `url(${Rectangle})`, width: '100%', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center', borderRadius: '30px' }}>
                {/* <imgBackground src={require("../../static/img/Rectangle124.png")} imgStyle={{ borderRadius: 30 }} style={{ resizeMode: 'contain' }}> */}
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', position: 'relative', zIndex: 999 }}>

                    <img src={require("../../static/img/Rectangle3.png")} style={{ width: '110px', height: '110px', zIndex: 999, margin: '20px' }} ></img>
                    <div style={{ flexDirection: 'row', margin: 10 }}>
                        <img src={require("../../static/img/Group1000007721.png")} style={{ width: '32px', height: '32px', zIndex: 9, margin: '5px' }} ></img>
                        <img src={require("../../static/img/Group1000007722.png")} style={{ width: '32px', height: '32px', zIndex: 9, margin: '5px' }} ></img>
                    </div>
                </div>
                {/* <div style={{ transform: [{ translateY: -60 }], }}> */}
                <div style={{
                    backgroundImage: `url(${Rectangle2})`, width: '100%', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center'
                    , borderRadius: '30px', marginTop: '-60px',paddingBottom:'40px'
                }}>
                    {/* <imgBackground src={require("../../static/img/Rectangle123.png")} imgStyle={{ borderRadius: 30 }} style={{ resizeMode: 'contain' }}> */}
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row', justifyContent: 'flex-end'
                    }}>
                        <div style={{
                            display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', backgroundColor: '#9FC8FE', height: '30px', borderRadius: '8px', padding: '5px', alignItems: 'center', margin: '15px'
                            , borderTop:'1px solid #000' , borderLeft:'1px solid #000', borderBottom:'3px solid #000', borderRight:'3.5px solid #000'
                        }}>
                            <img src={require("../../static/img/Edit.png")} style={{ width: '16px', height: '16px', zIndex: 9, margin: '5px' }} ></img>
                            <div style={{
                                lineHeight: '16px', fontSize: '12px', fontWeight: 500, color: '#000000', marginRight: '5px'
                            }}>{t('Editthealias')}</div>
                        </div>

                    </div>
                    <div style={{ marginLeft: 30 }}>
                        <div style={{ fontWeight: 700, fontSize: '32px', color: '#000000', marginTop: '5px' }}>
                            Marianna
                        </div>
                        <div style={{ fontWeight: 500, fontSize: '18px', color: '#000000', marginTop: '5px' }}>
                            {t('ProductManager')}
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '5px' }}>
                            <img src={require("../../static/img/mianxing-gongsi1.png")} style={{ width: '16px', height: '16px', marginRight: '5px' }} ></img>
                            <div style={{
                                fontSize: '14px', fontWeight: 400, color: '#000'
                            }}>{t('HogwartsLabs')}</div>
                        </div>
                        <div style={{ fontSize: '12px', fontWeight: 400, lineHeight: '18px', marginTop: '15px', color: '#333333' }}>
                            {t('Web3entrepreneurdrivingdecentralizedinnovationsPassionateaboutreshapingindustriesthroughblockchain')}
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '20px' }}>
                            <div style={{ height: '20px', borderRadius: '10px', border: '1px solid  #000000', }}>
                                <div style={{ color: '#000000', lineHeight: '20px', fontSize: '12px', marginLeft: '5px', marginRight: '5px' }}>#GameFi</div>
                            </div>
                            <div style={{ height: '20px', borderRadius: '10px', border: '1px solid  #000000', marginLeft: '10px' }}>
                                <div style={{ color: '#000000', lineHeight: '20px', fontSize: '12px', marginLeft: '5px', marginRight: '5px' }}>#NFT</div>
                            </div>
                        </div>
                        <div style={{ marginTop: '25px', marginBottom: '25px' }}>
                            <div style={{ width: '302px', height: '48px', backgroundColor: '#FFB197', borderRadius: '33px', border: '1px solid #000', }}>

                            </div>
                            <div style={{
                                width: '302px', height: '48px', backgroundColor: '#FC774B', borderRadius: '33px', border: '1px solid #000', zIndex: 99,
                                display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: '-60px'
                            }}>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: '15px' }}>
                                    <img src={require("../../static/img/Rectangle3.png")} style={{ width: '30px', height: '30px', alignItems: 'center', marginRight: '5px' }} ></img>
                                    <div style={{ marginLeft: '10px' }}>
                                        <div style={{ fontWeight: 400, fontSize: '16px', color: '#fff', lineHeight: '15px' }}>
                                            Marianna
                                        </div>
                                        <div style={{ fontWeight: 400, fontSize: '12px', color: '#fff', lineHeight: '15px' }}>
                                            0x14…0D7k
                                        </div>
                                    </div>
                                </div>
                                <img src={require("../../static/img/Chat.png")} style={{ width: '24px', height: '24px', alignItems: 'center', marginRight: '20px' }} ></img>
                            </div>


                        </div>
                        <div>
                            <div style={{ display: 'flex', flexDirection: 'row', height: '24px', marginBottom: '15px' }}>
                                <img src={require("../../static/img/Group3631.png")} style={{ width: '24px', height: '24px', alignItems: 'center', marginRight: '10px' }} ></img>
                                <div style={{ lineHeight: '24px', fontSize: '15px', fontWeight: 400, color: '#000000' }}>
                                    +01 5284357617
                                </div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', height: '24px', marginBottom: '15px' }}>
                                <img src={require("../../static/img/Group3631.png")} style={{ width: '24px', height: '24px', alignItems: 'center', marginRight: '10px' }} ></img>
                                <div style={{ lineHeight: '24px', fontSize: '15px', fontWeight: 400, color: '#000000' }}>
                                    marianna@gmail.com
                                </div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', height: '24px', marginBottom: '15px' }}>
                                <img src={require("../../static/img/Group3631.png")} style={{ width: '24px', height: '24px', alignItems: 'center', marginRight: '10px' }} ></img>
                                <div style={{ lineHeight: '24px', fontSize: '15px', fontWeight: 400, color: '#000000' }}>
                                    @Marianna_617
                                </div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', height: '24px', marginBottom: '15px' }}>
                                <img src={require("../../static/img/Group3631.png")} style={{ width: '24px', height: '24px', alignItems: 'center', marginRight: '10px' }} ></img>
                                <div style={{ lineHeight: '24px', fontSize: '15px', fontWeight: 400, color: '#000000' }}>
                                    @Marianna_617
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* <div style={{
            position: 'fixed', bottom: 0, left: 0, width: '100%', height: '100px', backgroundColor: '#000',
            display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'
        }}>
            <div style={{ color: '#FFF', fontSize: '14px', width: '252px' }}>{t('Youdon'thaveyourowncardyetCreateonetoexchangewithme!')}</div>
            <div style={{ width: '90px', height: '48px',lineHeight:'48px',backgroundColor: "#5970C5", justifyContent: 'center', alignItems: 'center', borderRadius: 10 }}>
                <div style={{ fontSize: '16px', fontWeight: 500, color: '#FFF',textAlign:'center'}}>{t('Goto')}</div>
            </div>
        </div> */}
        <div style={{
            position: 'fixed', bottom: 0, left: 0, width: '100%', height: '100px', backgroundColor: '#000',
            display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'
        }}>
            <div style={{ color: '#FFF', fontSize: '14px', width: '252px' }}>{t('CheckothereventsMariannawillgo')}</div>
            <div style={{ width: '90px', height: '48px', lineHeight: '48px', backgroundColor: "#735BF2", justifyContent: 'center', alignItems: 'center', borderRadius: 10 }}>
                <div style={{ fontSize: '16px', fontWeight: 500, color: '#FFF', textAlign: 'center' }}>{t('Check')}</div>
            </div>
        </div>
    </div>
};

export default PersonalInformation;